import type { ChatViewerPresence } from '../../types/chat'
import { Pressable } from '../Common/Pressable'

const initialsOf = (name: string) =>
  name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

type PresenceStackProps = {
  viewers: ChatViewerPresence[]
  onClick?: () => void
}

export const PresenceStack = ({ viewers, onClick }: PresenceStackProps) => {
  const visible = viewers.slice(0, 4)
  const overflow = Math.max(0, viewers.length - visible.length)
  return (
    <Pressable className="chatPresenceStack" onClick={onClick} aria-label={`${viewers.length} viewing chat`}>
      {visible.map((viewer) => (
        <span key={viewer.uid} className="chatPresenceAvatar" title={viewer.displayName}>
          {viewer.photoURL ? <img src={viewer.photoURL} alt="" /> : initialsOf(viewer.displayName)}
        </span>
      ))}
      {overflow > 0 ? <span className="chatPresenceOverflow">+{overflow}</span> : null}
    </Pressable>
  )
}
